require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-aaronshaf-parcel-reasonml-starter.json") })
        }
      }, "path---package-unpublished-aaronshaf-parcel-reasonml-starter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-aaronshaf-parcel-reasonml-starter!./.cache/json/package-unpublished-aaronshaf-parcel-reasonml-starter.json
// module id = 927
// module chunks = 231608221292675